module.exports = __webpack_public_path__ + "static/media/02-2.89842b10.webp";